import initialState from './initialState';
import moment from 'moment';

export const ASSETS_LOADING = 'ASSETS_LOADING';
export const ADD_AUDIO_FOLDER = 'ADD_AUDIO_FOLDER';
export const EDIT_AUDIO_FOLDER = 'EDIT_AUDIO_FOLDER';
export const GET_AUDIO_FOLDER = 'GET_AUDIO_FOLDER';
export const DELETE_AUDIO_FOLDER = 'DELETE_AUDIO_FOLDER';
export const ADD_AUDIO_FILE = 'ADD_AUDIO_FILE';
export const EDIT_AUDIO_FILE = 'EDIT_AUDIO_FILE';
export const GET_AUDIO_FILE = 'GET_AUDIO_FILE';
export const DELETE_AUDIO_FILE = 'DELETE_AUDIO_FILE';
export const ADD_CLIP_FOLDER = 'ADD_CLIP_FOLDER';
export const EDIT_CLIP_FOLDER = 'EDIT_CLIP_FOLDER';
export const GET_CLIP_FOLDER = 'GET_CLIP_FOLDER';
export const DELETE_CLIP_FOLDER = 'DELETE_CLIP_FOLDER';
export const ADD_CLIP_FILE = 'ADD_CLIP_FILE';
export const EDIT_CLIP_FILE = 'EDIT_CLIP_FILE';
export const GET_CLIP_FILE = 'GET_CLIP_FILE';
export const DELETE_CLIP_FILE = 'DELETE_CLIP_FILE';

export default function assetsReducer(state = initialState.assetsReducer, action) {
  switch (action.type) {
    case ASSETS_LOADING:
      return {
        ...state,
        loading: action.payload
      }
    case ADD_AUDIO_FOLDER:
      return {
        ...state,
        audioFolderData: [...state.audioFolderData, action.payload]
      };
    case GET_AUDIO_FOLDER:
      return  {
        ...state,
        audioFolderData: action.payload
      };
    case EDIT_AUDIO_FOLDER: {
      let { id, name } = action.payload;
      let index = state.audioFolderData.findIndex(x => x.id === id);
      let audioFolderData = [...state.audioFolderData];
      let folder = {...audioFolderData[index], name, modified: moment()};
      audioFolderData.splice(index, 1, folder);
      return  {
        ...state,
        audioFolderData,
      };
    }
    case DELETE_AUDIO_FOLDER: {
      let { folders } = action.payload;
      let audioFolderData = [...state.audioFolderData];
      audioFolderData = audioFolderData.filter(x => !folders.includes(x.id));
      return  {
        ...state,
        audioFolderData
      };
    }
    case ADD_AUDIO_FILE:
      return {
        ...state,
        audioFileData: [...state.audioFileData, action.payload]
      };
    case GET_AUDIO_FILE:
      return  {
        ...state,
        audioFileData: action.payload
      };
    case EDIT_AUDIO_FILE: {
      let { id, name } = action.payload;
      let index = state.audioFileData.findIndex(x => x.id === id);
      let audioFileData = [...state.audioFileData];
      let folder = {...audioFileData[index], name, modified: moment()};
      audioFileData.splice(index, 1, folder);
      return  {
        ...state,
        audioFileData,
      };
    }
    case DELETE_AUDIO_FILE: {
      let { id } = action.payload;
      let index = state.audioFileData.findIndex(x => x.id === id);
      let audioFileData = [...state.audioFileData];
      audioFileData.splice(index, 1);
      return  {
        ...state,
        audioFileData
      };
    }
    case ADD_CLIP_FOLDER:
      return {
        ...state,
        clipFolderData: [...state.clipFolderData, action.payload]
      };
    case GET_CLIP_FOLDER:
      return  {
        ...state,
        clipFolderData: action.payload
      };
    case EDIT_CLIP_FOLDER: {
      let { id, name } = action.payload;
      let index = state.clipFolderData.findIndex(x => x.id === id);
      let clipFolderData = [...state.clipFolderData];
      let folder = {...clipFolderData[index], name, modified: moment()};
      clipFolderData.splice(index, 1, folder);
      return  {
        ...state,
        clipFolderData,
      };
    }
    case DELETE_CLIP_FOLDER: {
      let { folders } = action.payload;
      let clipFolderData = [...state.clipFolderData];
      clipFolderData = clipFolderData.filter(x => !folders.includes(x.id));
      return  {
        ...state,
        clipFolderData
      };
    }
    case ADD_CLIP_FILE:
      return {
        ...state,
        clipFileData: [...state.clipFileData, action.payload]
      };
    case GET_CLIP_FILE:
      return  {
        ...state,
        clipFileData: action.payload
      };
    case EDIT_CLIP_FILE: {
      let { id, name } = action.payload;
      let index = state.clipFileData.findIndex(x => x.id === id);
      let clipFileData = [...state.clipFileData];
      let folder = {...clipFileData[index], name, modified: moment()};
      clipFileData.splice(index, 1, folder);
      return  {
        ...state,
        clipFileData,
      };
    }
    case DELETE_CLIP_FILE: {
      let { id } = action.payload;
      let index = state.clipFileData.findIndex(x => x.id === id);
      let clipFileData = [...state.clipFileData];
      clipFileData.splice(index, 1);
      return  {
        ...state,
        clipFileData
      };
    }
    default:
      return state;
  }
}
